import React, { useEffect } from 'react';
import Layout from './components/Layout/Layout';
import { Route, Routes } from 'react-router-dom';
import HomePages from './pages/HomePages';
import ForCompanies from './pages/ForCompanies';
import { ThankYou } from './pages/ThankYou';
import './App.styles.scss';
import { saveUtmParams } from './utils/utm';


export function App() {
  useEffect(() => {
    saveUtmParams();
}, []);

  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route index element={<HomePages />} />
          <Route path='/for-companies' element={<ForCompanies />} />
        </Route>
        <Route path='/thank-you' element={<ThankYou />} />
      </Routes>
    </div>

  );
}
